module.exports = __webpack_public_path__ + "assets/5ace5b67953499a6e0067bf99cfda92c.mp3";